import { useContext } from "react";
import { DashboardContext } from "../../workspace_components/TenantAdministratorComponents/Dashboards/DashboardProvider";
import TemperatureRadialGaugeDisplayImage from "./images/TemperatureRadialGaugeDisplayImage.png";
import ThermometerScaleDisplayImage from "./images/ThermometerScaleDisplayImage.png";
import SpeedGaugeDisplayImage from "./images/SpeedGaugeDisplayImage.png";
import RadialGaugeDisplayImage from "./images/RadialGaugeDisplayImage.png";
import CompassDisplayImage from "./images/CompassDisplayImage.png";
const AnalogueGaugesWidgets = ({selectedWidgetBundle,setSelectedWidgetBundle}) =>{
    const {setShowWidgetsLibrary, setSelectedNewWidgetWindow} = useContext(DashboardContext);
    if(selectedWidgetBundle !== 'analogue_gauges') return null;
    return(
        <div className="widgets-library-container" style={{zIndex:"10"}}>
            <div className="widgets-library-header-container">
                <div style={{display:"flex",alignItems:"center"}}>
                    <p
                        style={{fontWeight:"bold",fontSize:"25px",marginRight:"10px"}}
                        onClick={() => setSelectedWidgetBundle('')}
                    >&#8592;</p>
                    <h3>Analogue gauges: Select widget</h3>
                </div>
                <p onClick={() =>{
                    setSelectedWidgetBundle('');
                    setShowWidgetsLibrary(false);
                }}>&#10006;</p>
            </div>
            <div className="widgets-library-body-container">
                <div className="widgets-library-grid">
                    <div className="widgets-bundle-container">
                        <h4>Temperature radial gauge</h4>
                        <img src={TemperatureRadialGaugeDisplayImage} style={{height:'120px'}}/>
                    </div>
                    <div className="widgets-bundle-container">
                        <h4>Thermometer scale</h4>
                        <img src={ThermometerScaleDisplayImage} style={{height:'120px'}}/>
                    </div>
                    <div className="widgets-bundle-container">
                        <h4>Speed gauge</h4>
                        <img src={SpeedGaugeDisplayImage} style={{height:'120px'}}/>
                    </div>
                    <div className="widgets-bundle-container"
                    onClick={() =>{
                        setSelectedWidgetBundle('');
                        setShowWidgetsLibrary(false);
                        setSelectedNewWidgetWindow('radial_gauge');
                    }}>
                        <h4>Radial gauge</h4>
                        <img src={RadialGaugeDisplayImage} style={{height:'120px'}}/>
                    </div>
                    <div className="widgets-bundle-container">
                        <h4>Compass</h4>
                        <img src={CompassDisplayImage} style={{height:'120px'}}/>
                    </div>
                </div>
            </div>
        </div>
    );
};
export default AnalogueGaugesWidgets;